import {React, useState, useEffect }from "react";
import {Card} from "primereact/card"
import style from "./MarketingStockCard.module.css"
import {Link} from "react-router-dom";
import noPhoto from "../../../common/image/no photo stub.jpg"
import {GetDateFromString} from "../../../common/jsHelpers"
import "./MarketingStockCard.css"

export const MarketingStockCard = ({id, name, shortDescription, start, end, imageUrls}) => {

    const [startTime, setStartTime] = useState(""); 
    const [endTime, setEndTime] = useState("");
   
    const setStartEndDateFromString = () => {
        debugger
        const minDateTime = "0001-01-01T00:00:00";
        if(start !== minDateTime && end !== minDateTime) {
            setStartTime(GetDateFromString(start))
            setEndTime(GetDateFromString(end))
        }
    }

    useEffect(() => {
        if(start && end){
            setStartEndDateFromString()
        }
    }, [start, end])

    const footer = (
        <>
        <Link to={`/stock/${id}`}>
                            <button className="cta">
                                <span className="hover-underline-animation">Детальніше</span>
                                <svg viewBox="0 0 46 16" height="10" width="30" xmlns="http://www.w3.org/2000/svg"
                                     id="arrow-horizontal">
                                    <path transform="translate(30)"
                                          d="M8,0,6.545,1.455l5.506,5.506H-30V9.039H12.052L6.545,14.545,8,16l8-8Z"
                                          data-name="Path 10" id="Path_10"></path>
                                </svg>
                            </button>
                        </Link>
        </>
    );

    const header = (
        <Link to={`/stock/${id}`}>
            <img src={imageUrls.length > 0 ? imageUrls[0] : noPhoto} alt="Card"/>
        </Link> 
    )

    const title = (
        <div className={`${style.title} `}>
            {name}
        </div>
    )

    const subTitle = (
        <span>{startTime} - {endTime}</span> 
    )

    return (
        <div className={`${style.stockCardWrapper} marketing-stock-card-custom flex justify-content-center` }>

            <Card title={title} subTitle={subTitle} footer={footer} header={header} className="md:w-25rem">
                    <div className={`${style.contentWrapper}`}>
                        <div className={`${style.text}`}>
                            {shortDescription}
                        </div>
                    </div>
            </Card>
        </div>
    )
}